export default __webpack_public_path__ + "static/media/project-modal-arrow-left.209deaab.svg";